import { createFileRoute } from '@tanstack/react-router'
import { BarChart2, Briefcase, CalendarCheck } from 'lucide-react'

import { ContactForm } from '../components/landing/ContactForm'
import { Footer } from '../components/landing/Footer'
import { Header } from '../components/landing/Header'
import { buildOgMeta } from '../utils/og'

const benefits = [
    {
        icon: CalendarCheck,
        title: 'Piactér és direkt foglalás',
        description:
            'Megjelenés a Long-Y piacterén direkt foglalási lehetőséggel, valamint folyamatos marketing támogatás és ügyfélszerzés.',
    },
    {
        icon: Briefcase,
        title: 'Komplex IT háttér',
        description:
            'Komplex IT háttér biztosítása számodra – akár a saját márkád arculatára szabva. Integrált videókonzultációs rendszer, chat funkció és online foglalási rendszer.',
    },
    {
        icon: BarChart2,
        title: 'Kész szakmai koncepciók',
        description:
            'Igény esetén kész szakmai koncepciók: részletesen kidolgozott programstruktúra, termék- és szolgáltatási csomagok.',
    },
]

function ForExpertsPage() {
    return (
        <div className="min-h-screen bg-off-white font-sans text-brand-dark">
            <Header />
            <main>
                <section className="relative overflow-hidden bg-off-white py-24">
                    <div className="absolute -right-40 -top-40 h-96 w-96 rounded-full bg-brand-yellow/10 blur-[120px]" />
                    <div className="absolute -bottom-40 -left-40 h-96 w-96 rounded-full bg-primary/10 blur-[120px]" />

                    <div className="relative mx-auto max-w-[1280px] px-6">
                        <div className="mb-16 text-center">
                            <div className="mb-6 inline-block rounded-full bg-brand-yellow px-4 py-1 text-[10px] font-bold uppercase tracking-widest text-brand-dark">
                                Szakembereknek
                            </div>
                            <h1 className="mb-6 text-4xl font-bold leading-tight text-brand-dark md:text-6xl">
                                Csatlakozz hozzánk
                                <br />
                                <span className="text-primary">szakértőként</span>
                            </h1>
                            <p className="mx-auto max-w-2xl text-lg leading-relaxed text-brand-gray">
                                Ha szakértőként csatlakoznál hozzánk, vedd fel velünk a kapcsolatot!
                                Szeretnéd szolgáltatásaidat egy egészségtudatos közösséggel
                                megosztani? A Long-Y Marketplace pontosan ezt a hidat építi fel
                                közted és a hosszú, egészséges élet iránt elkötelezett új ügyfelek
                                között.
                            </p>
                        </div>

                        <div className="mb-20">
                            <h2 className="mb-10 text-center text-2xl font-bold text-brand-dark">
                                Milyen előnyöd származik belőle?
                            </h2>
                            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
                                {benefits.map((benefit) => {
                                    const Icon = benefit.icon
                                    return (
                                        <div
                                            key={benefit.title}
                                            className="flex flex-col gap-4 rounded-[2rem] border border-slate-100 bg-white p-8 shadow-xl shadow-slate-100"
                                        >
                                            <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-primary/10">
                                                <Icon className="h-7 w-7 text-primary" />
                                            </div>
                                            <h3 className="text-base font-bold text-brand-dark">
                                                {benefit.title}
                                            </h3>
                                            <p className="text-sm leading-relaxed text-brand-gray">
                                                {benefit.description}
                                            </p>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>

                        <div className="mx-auto max-w-2xl">
                            <div className="mb-6">
                                <h2 className="text-2xl font-bold text-brand-dark mb-2">
                                    Vedd fel velünk a kapcsolatot!
                                </h2>
                                <p className="text-brand-gray">
                                    Töltsd ki az alábbi űrlapot, és hamarosan keresünk.
                                </p>
                            </div>
                            <ContactForm
                                mutation="sendExpertContactForm"
                                messagePlaceholder="Mutatkozzon be röviden: szakterülete, tapasztalata, elképzelései..."
                            />
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
        </div>
    )
}

export const Route = createFileRoute('/for-experts')({
    component: ForExpertsPage,
    loader: async ({ context }) => {
        const [, websiteSettings] = await Promise.allSettled([
            context.apiUtils.webContent.getAllPublic.ensureData(),
            context.apiUtils.websiteSettings.getPublic.ensureData(),
        ])
        return {
            websiteSettings: websiteSettings.status === 'fulfilled' ? websiteSettings.value : null,
        }
    },
    head: ({ loaderData }) => ({
        meta: buildOgMeta({
            title: 'Long-Y - Szakembereknek',
            url: `${import.meta.env.VITE_WEB_URL || ''}/for-experts`,
            websiteSettings: loaderData?.websiteSettings,
        }),
    }),
})
